































































import EhrButton from "./../interface/EhrButton.vue";
import SectionCard from "./../interface/SectionCard.vue";
import Vue from "vue";
export default Vue.extend({
  name: "dossier-card",
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    cardIcon: {
      type: String,
    },
    isValid: {
      type: Boolean,
    },
    isEditable: {
      type: Boolean,
      required: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasTopButtons: {
      type: Boolean,
      default: true,
    },
    hasRequestInProgress: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EhrButton,
    SectionCard,
  },
  data() {
    return {
      isTutorial: true,
    };
  },
});
